<template>
    <div class="UserManagement" v-loading.fullscreen.lock="fullscreenLoading" :style="{ height: Height - 105 + 'px'}">
        <el-container :style="{ height: Height - 105 + 'px'}">
            <el-header height="80px">
                <el-row>
                    <el-col>
                        <h2>客户管理</h2>
                    </el-col>
                    <el-col :span="12" style="text-align: left; padding-left: 10px;">
                         <el-popover
                            placement="bottom-start"
                            width="400"
                            trigger="manual"
                            v-model="visible">
                            <el-form ref="ruleForms" :model="queryform" label-width="100px">
                                <el-form-item label="客户名">
                                    <el-input v-model="queryform.keyword"></el-input>
                                </el-form-item>
                                <el-form-item label="公司名">
                                    <el-input v-model="queryform.company"></el-input>
                                </el-form-item>
                                <el-form-item label="手机号">
                                    <el-input v-model="queryform.mobile"></el-input>
                                </el-form-item>
                            </el-form>
                            <el-row>
                                <el-col style="text-align: right;">
                                    <el-button type="primary" @click="Reset">重置</el-button>
                                    <el-button type="primary" @click="ConfirmQuery">确认</el-button>
                                </el-col>
                            </el-row>
                            <el-button type="primary" slot="reference" @click="visible = !visible">查询</el-button>
                        </el-popover>
                    </el-col>
                    <el-col :span="12">
                        <el-button type="primary" @click="AddUser">新增</el-button>
                        <el-badge is-dot class="item" :hidden="totals == 0">
                            <el-button type="primary" @click="Customer">客户申请</el-button>
                        </el-badge>
                    </el-col>
                </el-row>
            </el-header>
            <el-main>
                <el-table :height="Height - 265" :data="tableData" border style="width: 100%">
                    <el-table-column prop="title" label="客户名" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="mobile" label="联系电话">
                    </el-table-column>
                    <el-table-column prop="sex" label="性别">
                        <template slot-scope="scope">
                            <span v-if="scope.row.sex === 1">男</span>
                            <span v-if="scope.row.sex === 2">女</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="company_name" label="公司名" show-overflow-tooltip>
                    </el-table-column>
                    <el-table-column prop="birthday" label="出生日期">
                    </el-table-column>
                    <el-table-column prop="email" label="Email">
                    </el-table-column>
                    <el-table-column prop="address" label="操作">
                        <template slot-scope="scope">
                            <el-button type="text" @click="AccessControlAuthorization(scope.row)">门禁授权</el-button>
                            <el-button type="text" @click="EditUser(scope.row)">编辑</el-button>
                            <el-button type="text" @click="DelUser(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-dialog :title="title" :visible.sync="User" top="7vh" width="700px" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" custom-class="User">
                    <el-form :model="form" :rules="rules" ref="ruleForm" label-width="80px">
                        <el-form-item label="客户名" prop="title">
                            <el-input v-model="form.title"></el-input>
                        </el-form-item>
                        <el-form-item label="联系电话" prop="mobile">
                            <el-input v-model="form.mobile"></el-input>
                        </el-form-item>
                        <el-form-item label="性别">
                            <el-select v-model="form.sex" placeholder="请选择">
                                <el-option label="男" :value="1">
                                </el-option>
                                <el-option label="女" :value="2">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="公司名">
                            <el-select v-model="form.company_id" filterable remote placeholder="请选择" :remote-method="remoteMethod" :loading="loading">
                                <el-option v-for="item in CompanyList" :key="item.id" :label="item.title" :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="出生日期" prop="birthday">
                            <el-date-picker
                                v-model="form.birthday"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="Email" prop="email">
                            <el-input v-model="form.email" placeholder="请输入Email"></el-input>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <p class="tips">
                            <span>*注：公司名和Email为空的情况下客户不能接收账单</span>
                        </p>
                        <el-button @click="User = false">取 消</el-button>
                        <el-button type="primary" @click="SaveUser" :loading="confirmloding">确 定</el-button>
                    </div>
                </el-dialog>
                <el-dialog :title="title" :visible.sync="AccessControlAuthorizationShow" top="7vh" width="700px" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" custom-class="AccessControlAuthorizationShow" @opened="AccessControlSelect">
                    <el-form :model="forms" :rules="ruless" ref="ruleForms" label-width="120px">
                        <el-form-item label="权限开始时间" prop="dDateS" style="display: inline-block; width: 50%;">
                            <el-date-picker
                                v-model="forms.dDateS"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item label="权限结束时间" prop="dDateE" style="display: inline-block; width: 50%;">
                            <el-date-picker
                                v-model="forms.dDateE"
                                type="date"
                                value-format="yyyy-MM-dd"
                                placeholder="选择日期">
                            </el-date-picker>
                        </el-form-item>
                    </el-form>
                    <el-table ref="multipleTable" :data="AccessControlListData" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange" border height="250">
                        <el-table-column type="selection" width="55" align="center">
                        </el-table-column>
                        <el-table-column prop="UID" label="间禁ID">
                        </el-table-column>
                        <el-table-column prop="title" label="间禁号">
                        </el-table-column>
                        <el-table-column prop="remark" label="备注" show-overflow-tooltip>
                    </el-table-column>
                    </el-table>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="AccessControlAuthorizationShow = false">取 消</el-button>
                        <el-button type="primary" @click="SaveAccessControlAuth" :loading="confirmloding">确 定</el-button>
                    </div>
                </el-dialog>
                <el-dialog title="客户申请列表" custom-class="Customer" :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="dialogTableVisible">
                    <el-popover
                            placement="bottom-start"
                            width="400"
                            trigger="manual"
                            v-model="visibles">
                            <el-form ref="ruleForms" :model="Customerform" label-width="100px">
                                <el-form-item label="手机号">
                                    <el-input v-model="Customerform.mobile"></el-input>
                                </el-form-item>
                                <el-form-item label="公司名">
                                    <el-input v-model="Customerform.company"></el-input>
                                </el-form-item>
                                <el-form-item label="状态">
                                    <el-select style="width: 100%;" v-model="Customerform.status" placeholder="请选择">
                                        <el-option
                                        label="未处理"
                                        :value="0">
                                        </el-option>
                                        <el-option
                                        label="已处理"
                                        :value="1">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-form>
                            <el-row>
                                <el-col style="text-align: right;">
                                    <el-button type="primary" @click="Resets">重置</el-button>
                                    <el-button type="primary" @click="ConfirmCustomer">确认</el-button>
                                </el-col>
                            </el-row>
                            <el-button type="primary" slot="reference" @click="visibles = !visibles">查询</el-button>
                        </el-popover>
                    <el-table :height="Height - 480" :data="CustomerData" border style="width: 100%">
                        <el-table-column prop="user_name" label="客户名" show-overflow-tooltip>
                        </el-table-column>
                        <el-table-column prop="mobile" label="联系电话">
                        </el-table-column>
                        <el-table-column prop="sex" label="性别">
                            <template slot-scope="scope">
                                <span v-if="scope.row.sex === 1">男</span>
                                <span v-if="scope.row.sex === 2">女</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="company_name" label="公司名">
                        </el-table-column>
                        <el-table-column prop="status" label="状态">
                            <template slot-scope="scope">
                                <span v-if="scope.row.status === 0">未处理</span>
                                <span v-if="scope.row.status === 1">已处理</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="remark" label="拒绝理由">
                        </el-table-column>
                        <el-table-column prop="address" label="操作">
                            <template slot-scope="scope">
                                <!-- <el-button type="text" @click="(scope.row)">门禁授权</el-button> -->
                                <el-button v-show="scope.row.status === 0" type="text" @click="agree(scope.row)">同意</el-button>
                                <el-button v-show="scope.row.status === 0" type="text" @click="refuse(scope.row)">拒绝</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div slot="footer" class="dialog-footer">
                        <el-row>
                            <el-col :span="6" style="text-align: left;">
                                <el-pagination
                                    @size-change="handleSizeChanges"
                                    @current-change="handleCurrentChanges"
                                    :current-page="currentPages"
                                    :page-sizes="[10, 20, 50, 100]"
                                    :page-size="Sizes"
                                    layout="total"
                                    :total="totals">
                                </el-pagination>
                            </el-col>
                            <el-col :span="12" style="text-align: center;">
                                <el-pagination
                                    @size-change="handleSizeChanges"
                                    @current-change="handleCurrentChanges"
                                    :current-page="currentPages"
                                    :page-sizes="[10, 20, 50, 100]"
                                    :page-size="Sizes"
                                    layout="prev, pager, next"
                                    :total="totals">
                                </el-pagination>
                            </el-col>
                            <el-col :span="6" style="text-align: right;">
                                <el-pagination
                                    @size-change="handleSizeChanges"
                                    @current-change="handleCurrentChanges"
                                    :current-page="currentPages"
                                    :page-sizes="[10, 20, 50, 100]"
                                    :page-size="Sizes"
                                    layout="->, sizes"
                                    :total="totals">
                                </el-pagination>
                            </el-col>
                        </el-row>
                    </div>
                </el-dialog>
                <el-dialog title="拒绝客户申请" :visible.sync="refuseTrue" top="7vh" width="600px" :close-on-click-modal="false" :close-on-press-escape="false" :show-close="false" custom-class="refuseTrue">
                    <el-form :model="refuseforms" :rules="refuseTruerules" ref="refuseruleForms">
                        <el-form-item label="拒绝理由" prop="remark">
                            <el-input
                                type="textarea"
                                autosize
                                placeholder="请输入内容"
                                v-model="refuseforms.remark">
                            </el-input>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="refuseTrue = false">取 消</el-button>
                        <el-button type="primary" @click="SaverefuseTrue">确 定</el-button>
                    </div>
                </el-dialog>
            </el-main>
            <el-footer>
                <el-row>
                    <el-col :span="6">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="Size"
                            layout="total"
                            :total="total">
                        </el-pagination>
                    </el-col>
                    <el-col :span="12" style="text-align: center;">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="Size"
                            layout="prev, pager, next"
                            :total="total">
                        </el-pagination>
                    </el-col>
                    <el-col :span="6">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="Size"
                            layout="->, sizes"
                            :total="total">
                        </el-pagination>
                    </el-col>
                </el-row>
            </el-footer>
        </el-container>
  </div>
</template>

<script>
/*eslint-disable */
import { getToken, getAdminId } from "../../../utils/auth";
import https from "../../../utils/http";
export default {
    name: "UserManagement",
    data () {
        return {
            url: https.http,
            visible: false,
            fullscreenLoading: false,
            tableData: [],
            User: false,
            form: {
                title: '',
                mobile: '',
                sex: 1,
                company_name: '',
                company_id: '',
                birthday: '',
                email: ''
            },
            title: '',
            currentPage: 1,
            Size: 20,
            total: 1,
            visible: false,
            queryform: {
                keyword: '',
                company: '',
                mobile: ''
            },
            Uploaddata: {
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken()
            },
            http: https.https,
            preview: false,
            fileList: [],
            rules: {
                title: [
                    { required: true, message: '请输入用户名', trigger: 'blur' }
                ],
                mobile: [
                    { required: true, message: '请输入电话', trigger: 'blur' },
                    { pattern: /^1[3456789]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
                ],
                birthday: [
                    { required: true, message: '请选择出生日期', trigger: 'blur' }
                ],
                email: [
                    // { required: true, message: '请输入Email', trigger: 'blur' },
                    { pattern: /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/, message: 'Email格式不正确', trigger: 'blur' }
                ]
            },
            confirmloding: false,
            CompanyList: [],
            loading: false,
            AccessControlAuthorizationShow: false,
            AccessControlListData: [],
            multipleSelection: [],
            userid: '',
            forms: {
                dDateS: '',
                dDateE: ''
            },
            ruless: {
                dDateS: [
                    { required: true, message: '请选择权限开始日期', trigger: 'blur' }
                ],
                dDateE: [
                    { required: true, message: '请选择权限结束日期', trigger: 'blur' }
                ]
            },
            dialogTableVisible: false,
            Customerform: {
                mobile: '',
                company: '',
                status: 0
            },
            currentPages: 1,
            Sizes: 20,
            totals: 1,
            fullscreenLoadings: false,
            CustomerData: [],
            visibles: false,
            refuseTrue: false,
            refuseforms: {
                remark: ''
            },
            refuseTruerules: {
                remark: [
                    { required: true, message: '请输入拒绝理由', trigger: 'blur' }
                ]
            },
            refuseId: ''
        }
    },
    mounted() {

    },
    watch: {

    },
    methods: {
        // 客户申请列表
        ConfirmCustomer () {
            this.GetCustomer()
            let data = {
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken()
            };
            this.$store.dispatch("Isread", data).then(res => {
                console.log(res);
            });
        },
        Customer () {
            this.dialogTableVisible = true
            this.Customerform = {
                mobile: '',
                company: '',
                status: 0
            }
            this.currentPages = 1
            this.Sizes = 20
            this.totals = 1
            this.GetCustomer()
            let data = {
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken()
            };
            this.$store.dispatch("Isread", data).then(res => {
                console.log(res);
            });
        },
        GetCustomer () {
            let data = JSON.parse(JSON.stringify(this.Customerform))
            data.limit = this.Sizes
            data.page = this.currentPages
            data.ADMIN_ID = getAdminId()
            data.ADMIN_TOKEN = getToken()
            this.$store.dispatch('GetCustomerlist', data).then(res => {
                this.CustomerData = res.data
                this.totals = res.something
                this.refuseTrue = false
            })
        },
        // 确认门禁权限
        SaveAccessControlAuth () {
            let data = {
                userid: this.userid,
                dDateS: this.forms.dDateS,
                dDateE: this.forms.dDateE,
                UIDs: JSON.stringify(this.multipleSelection),
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken()
            }
            let that = this
            data.dDateE = data.dDateE + ' ' + '23:59:59'
            this.$refs['ruleForms'].validate((valid) => {
                if (valid) {
                    that.confirmloding = true
                    that.$store.dispatch('SaveAccessControlAuth', data).then(res => {
                        that.confirmloding = false
                        if (res.flag) {
                            that.$message({
                                message: res.message,
                                type: 'success'
                            })
                            that.AccessControlAuthorizationShow = false
                        } else {
                            that.$message({
                                message: res.message,
                                type: 'warning'
                            })
                        }
                    })
                } else {
                    return false;
                }
            })
        },
        // 同意
        agree(row) {
            let data = {
                id: row.id,
                opreate: 1,
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken()
            }
            this.$store.dispatch('opreateinvite', data).then(res => {
                if (res.flag) {
                    // that.$message({
                    //     message: res.message,
                    //     type: 'success'
                    // })
                    let row = {
                        id: res.data
                    }
                    this.GetCustomer()
                    this.AccessControlAuthorization(row)
                    this.HongDian()
                } else {
                    this.$message({
                        message: res.message,
                        type: 'warning'
                    })
                }
            })
        },
        // 拒绝
        refuse(row) {
            this.refuseTrue = true
            this.refuseId = row.id
        },
        SaverefuseTrue () {
            let that = this
            let data = {
                id: this.refuseId,
                opreate: 2,
                remark: this.refuseforms.remark,
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken()
            }
            this.$refs['refuseruleForms'].validate((valid) => {
                if (valid) {
                    that.$store.dispatch('opreateinvite', data).then(res => {
                        if (res.flag) {
                            that.$message({
                                message: '拒绝成功',
                                type: 'success'
                            })
                            that.GetCustomer()
                            that.HongDian()
                        } else {
                            that.$message({
                                message: '拒绝失败',
                                type: 'warning'
                            })
                        }
                    })
                } else {
                    return false;
                }
            })
        },
        handleSelectionChange (selections) {
            this.multipleSelection = selections
        },
        AccessControlSelect () {
            this.AccessControlListData.forEach(row => {
                if (Number(row.is_select) === 1) {
                    this.$refs.multipleTable.toggleRowSelection(row, true);
                } else {
                    this.$refs.multipleTable.toggleRowSelection(row, false);
                }
            });
        },
        AccessControlAuthorization (row) {
            console.log(row)
            this.userid = row.id
            let data = {
                userid: row.id,
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken()
            }
            this.title = '门禁授权'
            this.$store.dispatch('AccessControlListShows', data).then(res => {
                if (res.message !== "权限验证失败") {
                    this.AccessControlAuthorizationShow = true
                    this.AccessControlListData = res.data
                    this.forms.dDateS = res.something.dDateS.split(' ')[0]
                    this.forms.dDateE = res.something.dDateE.split(' ')[0]
                } else {
                    this.$message({
                        message: res.message,
                        type: 'warning'
                    })
                }
            })
        },
        AddUser () {
            this.User = true
            this.title = '新增用户'
            this.form = {
                title: '',
                mobile: '',
                sex: 1,
                company_name: '',
                company_id: '',
                birthday: '',
                email: ''
            }
            this.fileList = []
            this.GetCompanyList()
        },
        handleSizeChanges () {
            this.currentPages = page
            this.fullscreenLoadings = true
        },
        handleCurrentChanges () {
            this.Sizes = size
            this.fullscreenLoadings = true
        },
        handleSizeChange(size) {
            this.Size = size
            this.fullscreenLoading = true
            this.GetUserList(this.queryform.keyword, this.queryform.company)
        },
        handleCurrentChange(page) {
            this.currentPage = page
            this.fullscreenLoading = true
            this.GetUserList(this.queryform.keyword, this.queryform.company)
        },
        GetUserList (keyword, company) {
            let data = {
                keyword: keyword,
                company: company,
                limit: this.Size,
                page: this.currentPage,
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken(),
                mobile: this.queryform.mobile
            }
            this.$store.dispatch('UserListShow', data).then(res => {
                this.fullscreenLoading = false
                this.total = res.something
                this.visible = false
                this.tableData = res.data
                this.form = {
                    title: '',
                    mobile: '',
                    sex: 1,
                    company_name: '',
                    company_id: '',
                    birthday: '',
                    email: ''
                }
            })
        },
        Resets () {
            this.Customerform = {
                mobile: '',
                company: '',
                status: 0
            }
        },
        Reset () {
        //    this.$refs['ruleForms'].resetFields();
           this.queryform = {
                keyword: '',
                company: ''
            }
        },
        ConfirmQuery() {
            this.fullscreenLoading = true
            this.currentPage = 1
            this.GetUserList(this.queryform.keyword, this.queryform.company)
        },
        SaveUser() {
            let that = this
            let data = JSON.parse(JSON.stringify(this.form))
            data.ADMIN_ID = getAdminId();
            data.ADMIN_TOKEN = getToken();
            data.img = JSON.stringify(this.form.img)
            if (data.company_id !== '') {
                for (let item in this.CompanyList) {
                    if (this.CompanyList[item].id === data.company_id) {
                        data.company_name = this.CompanyList[item].title
                    }
                }
            }
            data.dDateE = data.dDateE + ' ' + '23:59:59'
            this.$refs['ruleForm'].validate((valid) => {
                if (valid) {
                    this.confirmloding = true
                    that.$store.dispatch('SaveUser', data).then(res => {
                        that.confirmloding = false
                        if (res.flag) {
                            that.$message({
                                message: res.message,
                                type: 'success'
                            })
                            that.User = false
                            that.fullscreenLoading = true
                            that.GetUserList(that.queryform.keyword, that.queryform.company)
                        } else {
                            that.$message({
                                message: res.message,
                                type: 'warning'
                            })
                        }
                    })
                } else {
                    // that.$message({
                    //     message: '请先填写必填项',
                    //     type: 'error'
                    // })
                    return false;
                }
            });
            
        },
        EditUser(row) {
            this.User = true
            this.title = '编辑用户'
            let rows = JSON.parse(JSON.stringify(row))
            rows.company_id = Number(rows.company_id)
            this.form = JSON.parse(JSON.stringify(rows))
        },
        DelUser(row) {
            this.$confirm('是否删除该用户？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                row.ADMIN_ID = getAdminId();
                row.ADMIN_TOKEN = getToken();
                this.$store.dispatch('DelUser', row).then(res => {
                     if (res.flag) {
                        this.$message({
                            message: res.message,
                            type: 'success'
                        })
                        this.fullscreenLoading = true
                        this.GetUserList(this.queryform.keyword, this.queryform.company)
                    } else {
                        this.$message({
                            message: res.message,
                            type: 'warning'
                        })
                    }
                })
            }).catch(() => {
            })
        },
        remoteMethod (query) {
            if (query !== '') {
                this.loading = true
                let data = {
                    keyword: query,
                    room: '',
                    limit: 100,
                    page: 1,
                    ADMIN_ID: getAdminId(),
                    ADMIN_TOKEN: getToken(),
                    status: 1
                }
                this.$store.dispatch('CompanyListShow', data).then(res => {
                    this.CompanyList = res.data
                    this.loading = false
                })
            } else {
                this.CompanyList = []
            }
        },
        GetCompanyList () {
            let data = {
                keyword: '',
                room: '',
                limit: 10000,
                page: 1,
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken()
            }
            this.$store.dispatch('CompanyListShow', data).then(res => {
                this.CompanyList = res.data
            })
        },
        HongDian () {
            let data = {
                ADMIN_ID: getAdminId(),
                ADMIN_TOKEN: getToken()
            };
            this.$store.dispatch("Isread", data).then(res => {
                console.log(res);
            });
        }
    },
    created() {
        this.fullscreenLoading = true
        this.GetCustomer()
        this.GetCompanyList()
        this.GetUserList(this.queryform.keyword, this.queryform.company)

    },
    computed: {
        Height() {
            return this.$store.state.loginModule.Height;
        }
    }
}
</script>

<style>
.UserManagement {
    width: 100%;
}
.UserManagement .el-header .el-row .el-col {
    height: 40px;
    line-height: 40px;
}
.UserManagement .el-header .el-row .el-col h2 {
    text-align: center;
}
.UserManagement .el-header .el-row .el-col {
    text-align: center;
}
.UserManagement .el-header .el-row .el-col:last-child {
    text-align: right;
}
.UserManagement .el-header .el-row .el-col .item {
    margin-left: 5px;
    vertical-align: top;
}
.UserManagement .el-main {
    padding-top: 0px;
    padding-bottom: 0px;
}
.UserManagement .el-main .User .el-dialog__body {
    padding-top: 0px;
    padding-bottom: 0px;
}
.UserManagement .el-main .User .el-select {
    width: 100%;
}
.UserManagement .el-main .AccessControlAuthorizationShow .el-dialog__body .el-date-editor {
    width: 100%;
}
.UserManagement .el-main .Customer .el-dialog__body {
    padding-top: 0px;
}
.UserManagement .el-main .Customer .el-dialog__body .el-table {
    margin-top: 10px;
}
</style>
